/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import React from "react";

export const RoundLoader = () => {
  const classes = styles();
  return (
    <div id={"round-loader"} css={classes.root}>
      Loading...
    </div>
  );
};

const styles = () => {
  return {
    root: css`
      color: #ffffff;
      font-size: 6px;
      margin: 32px auto;
      width: 1em;
      height: 1em;
      border-radius: 50%;
      position: relative;
      text-indent: -9999em;
      animation: load4 1.3s infinite linear;
      animation: load4 1.3s infinite linear;
      transform: translateZ(0);
      transform: translateZ(0);
      transform: translateZ(0);
      @media screen and (min-width: 768px) {
        font-size: 8px;
        margin: 48px auto;
      }
      @-webkit-keyframes load4 {
        0%,
        100% {
          box-shadow:
            0 -3em 0 0.2em,
            2em -2em 0 0em,
            3em 0 0 -1em,
            2em 2em 0 -1em,
            0 3em 0 -1em,
            -2em 2em 0 -1em,
            -3em 0 0 -1em,
            -2em -2em 0 0;
        }
        12.5% {
          box-shadow:
            0 -3em 0 0,
            2em -2em 0 0.2em,
            3em 0 0 0,
            2em 2em 0 -1em,
            0 3em 0 -1em,
            -2em 2em 0 -1em,
            -3em 0 0 -1em,
            -2em -2em 0 -1em;
        }
        25% {
          box-shadow:
            0 -3em 0 -0.5em,
            2em -2em 0 0,
            3em 0 0 0.2em,
            2em 2em 0 0,
            0 3em 0 -1em,
            -2em 2em 0 -1em,
            -3em 0 0 -1em,
            -2em -2em 0 -1em;
        }
        37.5% {
          box-shadow:
            0 -3em 0 -1em,
            2em -2em 0 -1em,
            3em 0em 0 0,
            2em 2em 0 0.2em,
            0 3em 0 0em,
            -2em 2em 0 -1em,
            -3em 0em 0 -1em,
            -2em -2em 0 -1em;
        }
        50% {
          box-shadow:
            0 -3em 0 -1em,
            2em -2em 0 -1em,
            3em 0 0 -1em,
            2em 2em 0 0em,
            0 3em 0 0.2em,
            -2em 2em 0 0,
            -3em 0em 0 -1em,
            -2em -2em 0 -1em;
        }
        62.5% {
          box-shadow:
            0 -3em 0 -1em,
            2em -2em 0 -1em,
            3em 0 0 -1em,
            2em 2em 0 -1em,
            0 3em 0 0,
            -2em 2em 0 0.2em,
            -3em 0 0 0,
            -2em -2em 0 -1em;
        }
        75% {
          box-shadow:
            0em -3em 0 -1em,
            2em -2em 0 -1em,
            3em 0em 0 -1em,
            2em 2em 0 -1em,
            0 3em 0 -1em,
            -2em 2em 0 0,
            -3em 0em 0 0.2em,
            -2em -2em 0 0;
        }
        87.5% {
          box-shadow:
            0em -3em 0 0,
            2em -2em 0 -1em,
            3em 0 0 -1em,
            2em 2em 0 -1em,
            0 3em 0 -1em,
            -2em 2em 0 0,
            -3em 0em 0 0,
            -2em -2em 0 0.2em;
        }
      }
      @keyframes load4 {
        0%,
        100% {
          box-shadow:
            0 -3em 0 0.2em,
            2em -2em 0 0em,
            3em 0 0 -1em,
            2em 2em 0 -1em,
            0 3em 0 -1em,
            -2em 2em 0 -1em,
            -3em 0 0 -1em,
            -2em -2em 0 0;
        }
        12.5% {
          box-shadow:
            0 -3em 0 0,
            2em -2em 0 0.2em,
            3em 0 0 0,
            2em 2em 0 -1em,
            0 3em 0 -1em,
            -2em 2em 0 -1em,
            -3em 0 0 -1em,
            -2em -2em 0 -1em;
        }
        25% {
          box-shadow:
            0 -3em 0 -0.5em,
            2em -2em 0 0,
            3em 0 0 0.2em,
            2em 2em 0 0,
            0 3em 0 -1em,
            -2em 2em 0 -1em,
            -3em 0 0 -1em,
            -2em -2em 0 -1em;
        }
        37.5% {
          box-shadow:
            0 -3em 0 -1em,
            2em -2em 0 -1em,
            3em 0em 0 0,
            2em 2em 0 0.2em,
            0 3em 0 0em,
            -2em 2em 0 -1em,
            -3em 0em 0 -1em,
            -2em -2em 0 -1em;
        }
        50% {
          box-shadow:
            0 -3em 0 -1em,
            2em -2em 0 -1em,
            3em 0 0 -1em,
            2em 2em 0 0em,
            0 3em 0 0.2em,
            -2em 2em 0 0,
            -3em 0em 0 -1em,
            -2em -2em 0 -1em;
        }
        62.5% {
          box-shadow:
            0 -3em 0 -1em,
            2em -2em 0 -1em,
            3em 0 0 -1em,
            2em 2em 0 -1em,
            0 3em 0 0,
            -2em 2em 0 0.2em,
            -3em 0 0 0,
            -2em -2em 0 -1em;
        }
        75% {
          box-shadow:
            0em -3em 0 -1em,
            2em -2em 0 -1em,
            3em 0em 0 -1em,
            2em 2em 0 -1em,
            0 3em 0 -1em,
            -2em 2em 0 0,
            -3em 0em 0 0.2em,
            -2em -2em 0 0;
        }
        87.5% {
          box-shadow:
            0em -3em 0 0,
            2em -2em 0 -1em,
            3em 0 0 -1em,
            2em 2em 0 -1em,
            0 3em 0 -1em,
            -2em 2em 0 0,
            -3em 0em 0 0,
            -2em -2em 0 0.2em;
        }
      }
    `,
  };
};
